import Swiper from 'swiper'

function cepingComment() {
  let el = document.querySelectorAll('.ceping-comment-wrapper')
  if (el) {
    let elArray = Array.from(el)
    elArray.map(initScroller)
  }
}
function initScroller(el) {
  let containerH = el.offsetHeight
  let totalH = el.querySelector('.swiper-wrapper').offsetHeight
  let percentage = totalH > containerH ? totalH / containerH : 1
  let itemNumber = document.querySelectorAll('.swiper-wrapper .comment-item')
    .length
  new Swiper(el, {
    scrollbar: '.swiper-scrollbar',
    direction: 'vertical',
    slidesPerView: 'auto',
    mousewheelControl: true,
    loop: itemNumber > 2 ? true : false,
    freeMode: true,
    roundLengths: true, //防止文字模糊,
    autoplay: true,
    speed: 5000 * percentage
  })
  // let maxScroll = bs.scrollerHeight - bs.wrapperHeight
  // let scrollTime = maxScroll * 20
  // console.log(maxScroll + 'px', scrollTime)
  // function play() {
  //   bs.scrollTo(0, -maxScroll, scrollTime, {
  //     // easeOutQuint
  //     swipe: {
  //       style: 'cubic-bezier(0, 0, 1, 1)',
  //       fn: function(t) {
  //         return 1
  //       }
  //     },
  //     // easeOutQuard
  //     swipeBounce: {
  //       style: 'cubic-bezier(0, 0, 1, 1)',
  //       fn: function(t) {
  //         return 1
  //       }
  //     },
  //     // easeOutQuart
  //     bounce: {
  //       style: 'cubic-bezier(0, 0, 1, 1)',
  //       fn: function(t) {
  //         return 1
  //       }
  //     }
  //   })
  // }

  // bs.on('scrollEnd', e => {
  //   let isEnd = maxScroll + e.y <= 0 // maxScroll 等于 -e.y 表示已经滑动到底部
  //   let resetTime = isEnd ? 400 : 0
  //   let leftScroll = maxScroll + e.y // 剩余的距离
  //   let leftScrollTime = scrollTime * (leftScroll / maxScroll)
  //   console.log('isEnd', isEnd, leftScroll, leftScrollTime)
  //   bs.scrollTo(0, 0, isEnd ? resetTime : leftScrollTime)
  //   setTimeout(() => {
  //     play()
  //   }, resetTime)
  // })
  // play()
}
export default cepingComment



// WEBPACK FOOTER //
// ./src/pages/promotion/template/components/cepingComment.js